/**
 * Vendor Application selector functions
 */
import { createSelector } from 'reselect';

const vendorApplicationReducer = (state) =>
  state.get('vendorApplicationReducer');

/**
 * Retrieves vendor state from vendor application reducer
 */
export const vendorSelector = createSelector(
  vendorApplicationReducer,
  (state) => state.get('vendor').toJS(),
);

/**
 * Retrieves loading state from vendor application reducer
 */

export const vendorLoadingSelector = createSelector(
  vendorApplicationReducer,
  (state) => state.get('loading'),
);

/**
 * Retrieves public files state from vendor application reducer
 */
export const publicFilesUrlsSelector = createSelector(
  vendorApplicationReducer,
  (state) => state.get('publicFilesUrls').toJS(),
);

/**
 * Retrieves the vendor contact error from the vendor application reducer
 */
export const vendorContactErrorSelector = createSelector(
  vendorApplicationReducer,
  (state) => state.get('vendorContactError'),
);
